import { Map as ProtobufMap } from 'google-protobuf';
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import { Duration } from 'google-protobuf/google/protobuf/duration_pb';
import { Struct } from 'google-protobuf/google/protobuf/struct_pb';
import { StringValue } from 'google-protobuf/google/protobuf/wrappers_pb';

export type GoogleExportClasses = {
  ProtobufMap: typeof ProtobufMap;
  Duration: typeof Duration;
  Timestamp: typeof Timestamp;
  Struct: typeof Struct;
  StringValue: typeof StringValue;
};

export const google: GoogleExportClasses = {
  ProtobufMap,
  Duration,
  Timestamp,
  Struct,
  StringValue,
};
